import React from 'react'
import { render } from 'react-dom'
import { Router } from '@reach/router'
import * as serviceWorker from './service-worker'

import Home from './components/Home'
import Connect from './components/Connect'
import New from './components/New'
import Join from './components/Join'

import { GlobalStyles } from './styles/global'
import { Provider as ApolloProvider } from './graphql/client'
import { Provider as ThemeProvider } from './styles/theme'
import { UserProvider } from './context/user'

const Routes = () => (
	<Router id="router">
		<Connect path="/connect" />
		<New path="/new" />
		<Join path="/join" />
		<Home path="/" />
	</Router>
)

const Index = () => (
	<>
		<GlobalStyles />
		<ApolloProvider>
			<ThemeProvider>
				<UserProvider>
					<Routes />
				</UserProvider>
			</ThemeProvider>
		</ApolloProvider>
	</>
)

render(<Index />, document.querySelector('#app'))

serviceWorker.register()
